export default {
  state: {
    isSelectStore: false, // 是否触发选择门店
    storeInfo: {},
    formList: [],
    questionnaireInfo: {},
    cmsDetail: {}, // 消息详情需要信息
    questionnaireSubmitInfo: {
      storeId: '',
      storeName: ''
    },
    storeList: [],
    selectStore: {} // 选中的门店信息
  },
  mutations: {
    // 重置信息
    resetInfo (state) {
      state = {
        isSelectStore: false, // 是否触发选择门店
        storeInfo: {},
        formList: [],
        cmsDetail: {},
        questionnaireInfo: {},
        questionnaireSubmitInfo: {
          storeId: '',
          storeName: ''
        },
        storeList: [],
        selectStore: {} // 选中的门店信息
      }
      console.log(state, 'state-store-----------')
    },
    setQuestionnaireInfo (state, { formList, questionnaireInfo, questionnaireSubmitInfo, cmsDetail }) {
      console.log(888, formList, questionnaireInfo, questionnaireSubmitInfo, cmsDetail)
      state.formList = formList
      state.questionnaireInfo = questionnaireInfo
      state.questionnaireSubmitInfo = questionnaireSubmitInfo
      state.cmsDetail = cmsDetail
    },
    // formlist 根据门店id更换以后重新请求自动会填数据的填充内容
    setForm (state, list) {
      state.formList = list
      console.log(state.formList, 'state.formList-----------')
    },
    setFormItem (state, { form, value }) {
      form.formValue = value
    },
    setStoreList (state, list) {
      state.storeList = list
    },
    // 选择门店，存储
    setSelectStore (state, { storeId, storeName }) {
      state.questionnaireSubmitInfo.storeId = storeId
      state.questionnaireSubmitInfo.storeName = storeName
    },
    // 是否触发选择门店
    setSelectStoreStatus (state, value) {
      state.isSelectStore = value
    }
  },
  getters: {
    getFormList: state => state.formList,
    getQuestionnaireInfo: state => state.questionnaireInfo,
    getQuestionnaireSubmitInfo: state => state.questionnaireSubmitInfo,
    storeList: state => state.storeList,
    selectStore: state => state.selectStore,
    getSelectStoreStatus: state => state.isSelectStore,
    getCmsDetail: state => state.cmsDetail
  }
}
